import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/production/git/fluent-ui/apps/backpack/src/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/home/production/git/fluent-ui/apps/backpack/src/layouts/empty.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/home/production/git/fluent-ui/apps/backpack/src/layouts/error.vue").then(m => m.default || m)),
  "labs-page": defineAsyncComponent(() => import("/home/production/git/fluent-ui/labs/core/layouts/labs-page.vue").then(m => m.default || m))
}